
{
  "fr": {
    "configuratorLayerEditorModalImageImport": {
      "instructions": {
        "formats": "Taille optimale de fichier recommandée\u00a0: {width}px\u00a0⨉\u00a0{height}px.",
        "sizes": "Formats autorisés\u00a0: {formatList}.",
        "glue": " et "
      },
      "screenPrinting": {
        "warning": "Attention\u00a0: votre visuel sera converti en une seule couleur",
        "details": "Vous avez sélectionné\u00a0: visuel en une seule couleur d'impression"
      },
      "fromFile": {
        "label": "Sélectionner un fichier"
      },
      "aiGenImage": {
        "label": "Générer une image avec IA"
      },
      "action": {
        "moreInfo": "Plus d'informations"
      },
      "file": {
        "error": {
          "invalid": "Le fichier sélectionné est invalide.",
          "invalidSize": "@:configuratorLayerEditorModalImageImport.file.error.invalid La taille maximale autorisée est {size}.",
          "invalidType": {
            "message": "@:configuratorLayerEditorModalImageImport.file.error.invalid (formats autorisés\u00A0: {formats}).",
            "glue": " et "
          }
        }
      }
    }
  }
}
